import { parseAccountsForFeature } from '@/assets/scripts/parsers/accounts'

/** returns Accounts Balances
@return { Array }
*/
export const getAccountsBalances = state => parseAccountsForFeature(state.accountsBalances)

/** returns rupe reference info
@return { Object }
*/
export const getReferenceInfo = state => state.rupeReferenceInfo

/** returns rupe reference info
@return { Object }
*/
export const getRupeTaxTypes = state => state.rupeTaxTypes.map(el => {
    return {
        ...el,
        text: el.taxTypeDescription
    }
})

/** returns Product list for Emis Special
@return { Array }
*/
export const getEmisSpecialProductsList = state => state.emisSpecialProductsList

/** returns Product Values list for Emis Special
@return { Array }
*/
export const getEmisSpecialProductsValuesList = state => state.emisSpecialProductsValuesList
